import axios from "../utilities/api/axiosInstance";
import getTagList from "@utils/text/getTagList";
import { printInConsole } from "@utils/devtools/utils";

export async function getReplies({
  parentCommentID,
  ts = 0,
  cancelToken,
  accessToken,
}) {
  /*
  Returns the list of replies
  */

  let link;
  if (ts === 0) link = `feed/reply?parentCommentID=${parentCommentID}`;
  else link = `feed/reply?parentCommentID=${parentCommentID}&ts=${ts}`;

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(link),
    cancelToken: cancelToken,
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Replies Fetch response => ", response);

  if (response?.data?.success) {
    return response.data.response;
  }

  return [];
}

export async function createReply({ data, accessToken }) {
  /*
  data --> { feedID, parentCommentID, comment } ** ?? **

  returns the reply data or null
  */

  data.tagList = getTagList(data.comment);

  const response = await axios({
    method: "POST",
    url: encodeURI("feed/reply"),
    data: data,
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Create Reply response => ", response);

  if (response?.data?.success) {
    return response.data;
  } else if (
    response?.data?.success === false &&
    response?.data?.message === "Comment contains vulgar words"
  ) {
    return response.data;
  }

  return response.data;
}

export async function updateReply({ data, accessToken }) {
  /*
  data --> { feedID, commentID, parentCommentID, comment } ** ?? **

  returns true/false
  */

  // const tagList = getTagList(comment);
  const response = await axios({
    method: "PUT",
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    url: encodeURI("feed/reply"),
    data: data,
  });

  printInConsole("Edit comment response => ", response);

  if (response?.data) return response.data.success;

  return false;
}

export async function deleteReply({ feedID, commentID, accessToken }) {
  /*
  Returns true/false
  */

  const response = await axios({
    method: "DELETE",
    url: encodeURI("feed/reply"),
    data: { feedID, commentID },
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  if (response?.data) {
    return response.data.success;
  }
  return false;
}

export async function reportReply({ feedID, commentID, accessToken }) {
  /*
  Returns true/false
  */

  const response = await axios({
    method: "POST",
    url: encodeURI("feed/reply/report"),
    data: { feedID, commentID },
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Reply report response => ", response);

  // if (response?.data) return response.data.success;

  // return false;
  return response?.data;
}

export async function likeReply({ commentID, accessToken }) {
  /*
  Like request for comment-reply
  ----!! No return value !!----
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("feed/reply/like"),
    data: { commentID },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Reply Like response => ", response);
  return response?.data;
}

export async function unlikeReply({ commentID, accessToken }) {
  /*
  Unlike request for comment-reply
  ----!! No return value !!----
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("feed/reply/unlike"),
    data: { commentID },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Reply Unlike response => ", response);
}

export async function getReplyLikesList({
  commentID,
  ts = 0,
  cancelToken,
  accessToken,
}) {
  /*
  Returns the list of users who liked the comment-reply
  */

  let link;
  if (ts === 0) link = `feed/reply/like?commentID=${commentID}`;
  else link = `feed/reply/like?commentID=${commentID}&ts=${ts}`;

  const response = await axios({
    method: "GET",
    url: encodeURI(link),
    cancelToken: cancelToken,
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Reply LikeList response => ", response);

  if (response?.data?.success) return response.data.response;

  return [];
}
